<div class="custom-tariff-section">
  <h2 class="custom-tariff-title">Individueller Tarif: {{data.customTariffDescription.name}}</h2>

  <p class="custom-tariff-description">{{data.customTariffDescription.description}}</p>

  <p class="custom-tariff-note">Hinweis: Individuelle Tarife können nicht über das Dashboard angepasst werden. Für Änderungen oder weitere Informationen kontaktieren Sie bitte unseren Kundenservice.</p>
</div>
